<template>
  <v-navigation-drawer
    app
    class="app-drawer"
    :mini-variant.sync="mini"
    v-model="drawer"
    :width="drawerWidth"
    :dark="$vuetify.dark"
  >
    <v-toolbar color="white">
      <img src="/static/logo.svg" width="225px" alt="Lab On Locale Portable" />
    </v-toolbar>

    <div>
      <v-list :dense="drawerWidth !== 64">
        <template v-for="(item, key) in computeMenu">
          <v-list-item
            :key="key"
            :to="item.path"
            v-if="!item.meta.hiddenInMenu && checkAuth(item.meta)"
          >
            <v-list-item-icon>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    v-text="item.meta.icon"
                  ></v-icon>
                </template>

                <span>{{ $vuetify.lang.t('$vuetify.menu.' + item.meta.title) }}</span>
              </v-tooltip>
            </v-list-item-icon>

            <v-list-item-content v-if="drawerWidth !== 64">
              <v-list-item-title v-text="$vuetify.lang.t('$vuetify.menu.' + item.meta.title)"></v-list-item-title>
            </v-list-item-content>

            <!-- <v-list-item-action>
              <v-list-item-action-text>
                <v-sheet
                  class="px-2"
                  color="deep-purple"
                  rounded
                  dark
                ></v-sheet>
              </v-list-item-action-text>
            </v-list-item-action> -->
          </v-list-item>
        </template>
      </v-list>
    </div>

    <template v-slot:append>
      <div>
        <template v-if="drawerWidth === 64">
          <div class="d-flex">
            <v-btn
              icon
              large
              @click="handleDrawerCollapse"
              class="mx-auto"
            >
              <v-icon>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-else>
          <div class="d-flex">
            <v-spacer />
            <v-btn
              icon
              large
              @click="handleDrawerCollapse"
              class="mr-2">
              <v-icon>mdi-minus-circle-outline</v-icon>
            </v-btn>
          </div>
        </template>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { protectedRoute as routes } from '@/router/config'

export default {
  name: 'AppDrawer',
  components: {},
  props: {
    expanded: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      mini: false,
      drawerWidth: 256,
      drawer: true,
      scrollSettings: {
        maxScrollbarLength: 160
      }
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },

    computeMenu() {
      return routes[0].children
    }
  },
  created() {},
  methods: {
    checkAuth(auth) {
      return auth.authorize.includes(this.currentUser.roles.toString());
    },

    handleDrawerCollapse() {
      this.drawerWidth = this.drawerWidth === 256 ? 64 : 256
    },
    
    toggleDrawer() {
      this.drawer = !this.drawer
    }
  }
}
</script>

<style lang="sass" scoped>
.app-drawer
  overflow: hidden !important
  &__inner
    height: calc(100vh - 48px)
    overflow-y: scroll
  .drawer-menu--scroll
    height: calc(100vh - 48px)
    overflow: auto
</style>